import axiosApiClient from "..";
import { handleError } from "../../utils/errors";

const BASE_URL = "/period-event-data";

class PeriodEventDataService {
  fetchPeriodEventData = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { data } = response.data;
      return data;
    } catch (err) {
      throw handleError(err, "Error occured while fetching periodEventData.");
    }
  };
}

export default new PeriodEventDataService();
